<template>
    <div v-if="isVisible" class="windows" :style="{ left: left, width: width }">
        <component 
            :is="component"
            v-bind="payload" 
            @close="handleClose">
        </component>
    </div>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import WINDOWS from '@/constants/windows.js'
import WindowAbstract from './WindowAbstract.vue'
import WindowBase from './WindowBase.vue'

export default {
    name: 'Windows',
    props: {
        injected: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters('navigation', {
            isNavigationVisible: 'isVisible',
            isNavigationTemporary: 'isTemporary',
            getNavigationWidth: 'getWidth'
        }),
        ...mapGetters('windows', [
            'isVisible',
            'getComponent',
            'getPayload'
        ]),
        left() {
            if (this.isNavigationTemporary) return '0px'
            if (this.isNavigationVisible) return this.getNavigationWidth + 'px'
            return '0px'
        },
        width() {
            return `calc(100vw - ${this.left})`
        },
        component() {
            const allComponents = {
                [WINDOWS.ABSTRACT]: WindowAbstract,
                [WINDOWS.BASE]: WindowBase,
                ...this.injected
            }
            return allComponents[this.getComponent] || null
        },
        payload() {
            return this.getPayload
        }
    },
    watch: {
        $route() {
            this.close()
        }
    },
    methods: {
        ...mapActions('windows', [
            'close'
        ]),
        handleClose() {
            this.close()
        }
    }
}
</script>

<style scoped>
.windows {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 25px;
    z-index: 500;
    user-select: none;
    pointer-events: all;
    background-color: rgb(var(--v-theme-shadow1), 0.8);
    transition: width 0.3s ease, left 0.3s ease;
}

@media (max-width: 1200px) {
    .windows {
        padding: 20px;
    }
}

@media (max-width: 1000px) {
    .windows {
        padding: 15px;
    }
}

@media (max-width: 800px) {
    .windows {
        padding: 10px;
    }
}

@media (max-width: 600px) {
    .windows {
        padding: 5px;
    }
}

@media (max-width: 450px) {
    .windows {
        padding: 0px;
    }
}
</style>
